import { createStore } from 'vuex'
import testimonios from './testimonios'

export default createStore({
  state: {
    testimonios: testimonios,
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
